jQuery(document).ready(function($) {
    var $toc = $('.contents-list');
    var $tocList = $toc.find('.contents-list__list ul');
    var $headings = $('.blog-content').find('h1, h2, h3, h4, h5, h6');
    var $content = $('.col-blog-content');

    if (!$toc.length || !$headings.length) return;

    // Generate TOC
    $headings.each(function() {
        var $heading = $(this);
        var tag = $heading.prop('tagName').toLowerCase();
        var level = parseInt(tag.replace('h', ''), 10);
        var text = $heading.text().trim();
        var slug = $heading.attr('id');

        if (!slug) {
            slug = text.toLowerCase().replace(/[^\w]+/g, '-').replace(/^[-]+|[-]+$/g, '');
            $heading.attr('id', slug);
        }

        var $li = $('<li>')
            .addClass('toc-level-' + level)
            .append($('<a>').attr('href', '#' + slug).text(text));
        $tocList.append($li);
    });

    // Smooth scroll
    $tocList.on('click', 'a', function(e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top - 80
            }, 500);
        }
    });

    // Sticky simulation only on desktop (≥ 992px)
    function handleSticky() {
        if (window.innerWidth < 992) {
            // Remove sticky on mobile
            $toc.css({
                position: 'static',
                top: '',
                width: ''
            });
            return; // Skip sticky logic
        }

        var tocOriginalOffset = $toc.offset().top;
        var tocHeight = $toc.outerHeight();
        var stopPoint = $content.offset().top + $content.outerHeight() - tocHeight;
        var fixedTop = 100; // px from top

        $(window).on('scroll resize', function() {
            var scrollTop = $(window).scrollTop();

            if (scrollTop >= tocOriginalOffset && scrollTop + fixedTop < stopPoint) {
                $toc.css({
                    position: 'fixed',
                    top: fixedTop + 'px',
                    width: $toc.parent().width() + 'px'
                });
            } else if (scrollTop + fixedTop >= stopPoint) {
                $toc.css({
                    position: 'absolute',
                    top: (stopPoint - tocOriginalOffset) + 'px',
                    width: $toc.parent().width() + 'px'
                });
            } else {
                $toc.css({
                    position: 'static',
                    top: '',
                    width: ''
                });
            }
        }).trigger('scroll');
    }

    handleSticky();

    // Re-run on resize
    $(window).on('resize', handleSticky);
});
